// components/skeletons/PaginationSkeleton.jsx
import React from 'react';
import '../../styles/index.css';





    const PaginationSkeleton = () => {
    const { useState } = React;
         // Load sidebar state from localStorage
    const [isCollapsed, setIsCollapsed] = useState(() => {
        const saved = localStorage.getItem("sidebarCollapsed");
        return saved ? JSON.parse(saved) : false;
    });

    // Save sidebar state to localStorage
    const toggleSidebar = () => {
        const newState = !isCollapsed;
        setIsCollapsed(newState);
        localStorage.setItem("sidebarCollapsed", JSON.stringify(newState));
    };
  return (
    <div className="pagination-info">
      <div className="rows-per-page">
        <span>Rows per page:</span>
        <div className="skeleton-box" style={{ width: '60px', height: '30px' }} />
      </div>

      <div className="page-info-user">
        <div className="skeleton-box" style={{ width: '100px', height: '20px' }} />
      </div>

      <div
        className="pagination-buttons "
        style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
      >
        <div className={` ${isCollapsed ? 'expand' : 'shrink'}`} />
        <div className={` ${isCollapsed ? 'expand' : 'shrink'}`} />
      </div>
    </div>
  );
};

export default PaginationSkeleton;
